import * as React from 'react';
import {useContext} from 'react';
import { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { FullHeader, IntegrationHeader } from 'deda-rkit';
// import { ApiClient } from 'Portal/http_client/api_client';
// import { apiConfigurationDefault } from './http_client/api_configuration';

import AppProvider, { aggiungiElementoBageHeaderLinks } from './mixin/app_provider';
import { AppCtx } from './mixin/app_context';
const logo = require('../../../img/logo.svg');




export const App: FC = () => {
  // const apiConfiguration = apiConfigurationDefault; /* uso quella di default */
  // const apiClient = new ApiClient(apiConfiguration);
  const context = useContext(AppCtx);

  context.confEnte.header_links = aggiungiElementoBageHeaderLinks(context.confEnte.header_links, context.confEnte.notifiche_utente_non_lette,  context.confEnte.comunicazioni_utente_non_lette)

  console.log('contesto da api',context);
  
  return (
    <>
      <Router>
        <AppProvider context={context}>
        {(context?.confEnte.external_footer != null && 
          context?.confEnte.external_footer != '' &&
          context?.confEnte.external_header != null &&
          context?.confEnte.external_header != ''
          )?
          <IntegrationHeader  user={context.confEnte.utente_nome && context.confEnte.utente_cognome ?
              { nome: context.confEnte.utente_nome, cognome: context.confEnte.utente_cognome } : undefined
          } userLogged = {context.userLogged}  
          urlFetch={context.confEnte.external_header} baseUrl= {context.confEnte.base_url}
          ></IntegrationHeader>
          :
          <FullHeader
            sticky={context.confEnte.sticky_header}
            stickyLogin={true}
            user={
              {
                nome: (context.confEnte.utente_nome)? context.confEnte.utente_nome : '',
                cognome: (context.confEnte.utente_cognome) ? context.confEnte.utente_cognome : ''
              }
            }
            nomeEnte={context.confEnte.nome}
            stemma={context.confEnte.stemma}
            stemmaBurger={context.confEnte.stemma_burger}
            officialWebsite={context.confEnte.url_sito}
            userLogged={context.userLogged}
            headerLinks={context.confEnte.header_links}
            navigazioneReact={context.confEnte.navigazione_react}
            baseUrl={context.confEnte.base_url}
            regione = {context.confEnte.regione}
            regione_sito = {context.confEnte.regione_sito}
            classNameSticky=''
          />
          
        }
        </AppProvider>
      </Router>
    </>
  );
}